import "./SkeletonLoader.css";

const SkeletonCard = () => (
  <div className="skeleton-card">
    <div className="skeleton-header" />
    <div className="skeleton-body">
      <div className="skeleton-line short" />
      <div className="skeleton-line" />
      <div className="skeleton-line" />
    </div>
    <div className="skeleton-footer">
      <div className="skeleton-btn" />
    </div>
  </div>
);

const SkeletonLoader = ({ count = 6 }) => {
  const items = Array.from({ length: count });
  return (
    <div className="skeleton-grid">
      {items.map((_, i) => (
        <div key={i} className="skeleton-col">
          <SkeletonCard />
        </div>
      ))}
    </div>
  );
};

export default SkeletonLoader;
